// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__2-LoL","menu-btn":"Menu_menu-btn__-9jYb","menu-item":"Menu_menu-item__RXKwb","icon-wrp":"Menu_icon-wrp__yf87T"};